import AWS from 'aws-sdk';
import {Auth} from 'aws-amplify';

const submitFeedback = () => {

  return Auth.currentCredentials()
  .then(credentials => {

    const S3 = new AWS.S3(Auth.essentialCredentials(credentials));

    const params = {
      Bucket: 'weaveability-basis-utilities-storage',
      Prefix: 'feedback/feedback'
    };

    return S3.listObjects(params).promise()
    .then(res => {
      return Promise.all(res.Contents.map(object => {
        return S3.getObject({Bucket: 'weaveability-basis-utilities-storage', Key: object.Key}).promise();
      }));
    })
    .then(res => {
      return res.map(object => {
        return JSON.parse(object.Body.toString());
      });
    })
    .catch(err => {
      console.log(err);
    });

  })
  .catch(err => {
    console.log(err);
  });

};

export default submitFeedback;


// WEBPACK FOOTER //
// ./src/components/content/feedback/utils/downloadFeedback.js